import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import styles from './Column.styles'
import { toCurrencyStrategy } from '../../sections/EarningsCalculator/utils/toCurrencyStrategy'

export function getColumnStyles(value, baseValue, baseHeight) {
  if (baseValue === 0) {
    return null
  }
  const decimal = value / baseValue

  return {
    height: `${decimal * baseHeight}px`,
    maxHeight: `${decimal * 85}px`,
    minHeight: `${decimal * baseHeight}px`
  }
}

export function toCurrency(value, separator, classes, langKey) {
  const [integerValue, decimalValue] = toCurrencyStrategy(
    value,
    separator,
    langKey
  ).split(separator)

  return (
    <span data-testid="currencyValue">
      {integerValue}
      <span className={classes.currencySmallText}>
        {decimalValue ? separator : null}
        {decimalValue}
      </span>
    </span>
  )
}

const PureColumn = ({
  baseAmount,
  baseHeight,
  baseValue,
  classes,
  className,
  currency,
  level,
  hideValue,
  separator,
  value,
  langKey,
  valueLabel
}) => (
  <div data-testid={`earnings-calculator-chart-${level}`}>
    {!hideValue && <Typography
      className={clsx(classes.typography, classes.columnValue)}
      component="span"
    >
      <small aria-label="Reais">{currency}&nbsp;</small>
      {toCurrency((baseAmount * value) / 100, separator, classes, langKey)}
    </Typography>}
    <Typography variant="srOnly"> (</Typography>
    <Typography
      className={clsx(classes.root, classes.typography, className)}
      component="span"
      style={getColumnStyles(value, baseValue, baseHeight)}
    >
      <span>{valueLabel}%</span>
    </Typography>
    <Typography variant="srOnly">)</Typography>
  </div>
)

PureColumn.propTypes = {
  baseAmount: PropTypes.number,
  baseHeight: PropTypes.number,
  baseValue: PropTypes.number,
  classes: PropTypes.object,
  className: PropTypes.string,
  currency: PropTypes.string,
  separator: PropTypes.string,
  value: PropTypes.number,
  valueLabel: PropTypes.string,
  level: PropTypes.string
}

const Column = withStyles(styles)(PureColumn)

export default Column
